var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import styled from 'styled-components';
import { Field } from 'formik';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n\n  > h2 {\n    font-size: 24px;\n    margin-bottom: 10px;\n  }\n\n  > .title {\n    width: 100%;\n    height: 70px;\n    padding: 10px;\n\n    > input {\n      width: 100%;\n      height: 50px;\n      padding: 10px;\n      line-height: 30px;\n      text-align: center;\n      font-size: 18px;\n    }\n  }\n\n  > .content {\n    width: 100%;\n    padding: 10px;\n\n    > textarea {\n      padding: 10px;\n      font-size: 16px;\n      width: 100%;\n      height: 400px;\n    }\n  }\n"], ["\n  width: 100%;\n\n  > h2 {\n    font-size: 24px;\n    margin-bottom: 10px;\n  }\n\n  > .title {\n    width: 100%;\n    height: 70px;\n    padding: 10px;\n\n    > input {\n      width: 100%;\n      height: 50px;\n      padding: 10px;\n      line-height: 30px;\n      text-align: center;\n      font-size: 18px;\n    }\n  }\n\n  > .content {\n    width: 100%;\n    padding: 10px;\n\n    > textarea {\n      padding: 10px;\n      font-size: 16px;\n      width: 100%;\n      height: 400px;\n    }\n  }\n"])));
var Paragraph = /** @class */ (function (_super) {
    __extends(Paragraph, _super);
    function Paragraph() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Paragraph.prototype.render = function () {
        var idx = this.props.idx;
        return (React.createElement(Container, null,
            React.createElement("h2", null, "\uBB38\uC7A5\uD615"),
            React.createElement("div", { className: "title" },
                React.createElement(Field, { name: "components[" + idx + "].value.title", placeholder: "\uC81C\uBAA9" })),
            React.createElement("div", { className: "content" },
                React.createElement(Field, { component: "textarea", name: "components[" + idx + "].value.paragraph", placeholder: "\uBB38\uC7A5\uC744 \uC785\uB825\uD558\uC138\uC694" }))));
    };
    return Paragraph;
}(React.Component));
export default Paragraph;
var templateObject_1;
